// extracted by mini-css-extract-plugin
export default {"wrapper":"SaveButton_wrapper__vCpy4"};